<template>
    <Dialog :unlimit-height="true" v-model="show" @input="$listeners.input" :title="title" width="1280" :show-close-button="true">
        <v-item-group>
            <v-container>
                <v-row v-if="ambientes.length > 0">
                    <v-col v-for="(ambiente, index) in ambientes" @click="ativarAmbiente(ambiente)" :key="index" cols="12" sm="6" md="4" lg="3" xl="3" class="mb-4 mt-2 xs">
                        <v-item v-slot="{ active, toggle }">
                            <v-card
                                    :style="{ 'border-color': active ? 'var(--primary) !important' : '', 'border': active ? '2px solid var(--primary) !important' : '  ' }"
                                    @click="toggle" class="mx-auto" min-height="100%">
                                <div class="d-flex align-center" style="flex-direction:column;">
                                    <v-img class="logo mt-1 margin__break_point_sm" contain max-width='70%' max-height='90%'
                                           height="110px" width="100%" style="background-size: contain;"
                                           :src='"../../assets/flavors/" + ambiente.flavor + "/img/logo-menu.png"'></v-img>
                                </div>
                                <div class="text-center display-flex flex-align-center pb-4"
                                     :style="{ 'color': active ? 'var(--primary)' : 'grey', 'font-size': '15px', 'font-weight': 'bold', 'margin-bottom': active ? '0px' : 'inherit' }">
                                    {{ ambiente.codigo_empresa }} - {{ ambiente.nome_empresa }}
                                </div>
                            </v-card>
                        </v-item>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-col cols="12" class="mb-2 mt-2 text-center">
                        Nenhum ambiente disponível para o comissionado selecionado.
                    </v-col>
                </v-row>
            </v-container>
        </v-item-group>
    </Dialog>
</template>

<script>
  import commercialHierarchy from '@/mixins/commercialHierarchy'
  import { notification } from '../../plugins/helpers'
  import validarVigenciaPontosDeVenda from '../../mixins/CommercialHierarchy/validarVigenciaPontosDeVenda'
  import { AlertTypes } from '../../plugins/alerts_types'
  const rotaPadraoCasoIndefinido = 'cadastro'
  export default {
    name: 'DialogEscolhaAmbienteHierarchy',
    mixins: [commercialHierarchy, validarVigenciaPontosDeVenda],
    props: {
      value: { type: Boolean, default: true },
      ambientes: Array,
      rota: String,
      isEntrandoFluxoVenda: { type: Boolean, default: false }
    },
    data: () => ({
      title: 'SELECIONE UM AMBIENTE'
    }),
    computed: {
      show: {
        get () {
          return this.value
        },
        set (val) {
          if (!val) {
            this.isEntrandoFluxoVendaComputed = false
          }
          this.$emit('input', val)
        }
      },
      params () {
        return {
          gerenteNegocio: this.gerenteNegocio
        }
      },
      isEntrandoFluxoVendaComputed: {
        get () {
          return this.isEntrandoFluxoVenda
        },
        set (val) {
          this.$emit('setarEntrandoFluxoVenda', val)
        }
      }
    },
    methods: {
      async ativarAmbiente (ambiente) {
        try {
          const id_comissionado_venda = this.$session.get('id_comissionado_venda')
          const id_ponto_venda = this.$session.get('id_ponto_venda')
          const dataFimVigencia = this.$session.get('data_fim_vigencia')
          this.show = false
          const requestPermissaoTodosProdutos = await this.$http.get(`/flavor-permite-todos-produtos/${ambiente.flavor}`).catch(() => { return { data: { 'permiti_todos_produtos': false } } })

          if (this.isVigenciaFechada(dataFimVigencia)) {
            notification(AlertTypes.ERROR, 'O Ponto de Venda selecionado está com a vigência fechada e por isso não é possível lançar vendas no mesmo. Por favor, entre em contato com a Área de Suporte')
            return
          }
          await this.setarSessaoVendedorParaUsuarioGNRC(ambiente.flavor, ambiente.id_empresa, id_comissionado_venda, id_ponto_venda, ambiente.id_unidade_negocio)
          this.$session.set('permite_venda_todos_produtos', requestPermissaoTodosProdutos.data.permiti_todos_produtos)
          this.$router.replace({ name: this.rota ?? rotaPadraoCasoIndefinido, query: { redirecionamentoPainelLateral: true } })
        } catch (err) {
          notification('error', 'Não foi possível redirecionar para o ambiente escolhido, por favor tente novamente em instantes, caso persistir, entre em contato com a administradora.')
        }
      }
    }
  }
</script>

<style scoped>

</style>
